import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faCode, 
  faGlobe, 
  faEnvelope, 
  faChartLine, 
  faMobile, 
  faUsers, 
  faCheckCircle, 
  faBuilding, 
  faShoppingCart, 
  faGraduationCap, 
  faHeart, 
  faBars, 
  faTimes, 
  faStar, 
  faBolt, 
  faShield, 
  faAward,
  faArrowRight,
  faLaptopCode,
  faRocket,
  faDesktop,
  faBrain,
  faLightbulb,
  faInfinity,
  faChevronDown,
  faPlay,
  faPause,
  faExpand,
  faCompress,
  faGem,
  faWandMagicSparkles,
  faArrowUp,
  faChevronUp,
  faNetworkWired,
  faDatabase,
  faCloud,
  faPalette,
  faPencilRuler,
  faCog,
  faHandshake,
  faHeadset,
  faChartBar,
  faSearchPlus,
  faUserTie,
  faProjectDiagram,
  faBullhorn,
  faQuoteLeft,
  faPhone,
  faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';

import { 
  faLinkedin as faLinkedinBrand,
  faTwitter as faTwitterBrand,
  faFacebook as faFacebookBrand,
  faInstagram as faInstagramBrand,
  faGithub as faGithubBrand
} from '@fortawesome/free-brands-svg-icons';

// Add icons to the library
library.add(
  faCode, 
  faGlobe, 
  faEnvelope, 
  faChartLine, 
  faMobile, 
  faUsers, 
  faCheckCircle, 
  faBuilding, 
  faShoppingCart, 
  faGraduationCap, 
  faHeart, 
  faBars, 
  faTimes, 
  faStar, 
  faBolt, 
  faShield, 
  faAward,
  faArrowRight,
  faLaptopCode,
  faRocket,
  faDesktop,
  faBrain,
  faLightbulb,
  faInfinity,
  faChevronDown,
  faPlay,
  faPause,
  faExpand,
  faCompress,
  faGem,
  faWandMagicSparkles,
  faArrowUp,
  faChevronUp,
  faNetworkWired,
  faDatabase,
  faCloud,
  faPalette,
  faPencilRuler,
  faCog,
  faHandshake,
  faHeadset,
  faChartBar,
  faSearchPlus,
  faUserTie,
  faProjectDiagram,
  faBullhorn,
  faQuoteLeft,
  faPhone,
  faMapMarkerAlt,
  faLinkedinBrand,
  faTwitterBrand,
  faFacebookBrand,
  faInstagramBrand,
  faGithubBrand
); 